import { Badge, BadgeVariant } from '@/lib/core/components/Badge'
import { Truncate } from '@/lib/core/components/Truncate'

import { useTagsStore } from '../../store'
import { AssetTag, ModalOpenVariant } from '../TableHeaderTags/TableHeaderTags.types'
import { TagsListProps } from './TagsList.types'
import styles from '../TableHeaderTags/TableHeaderTags.module.css'

export const TagsList = ({
  maxTagsRenderCount,
  openModal,
  modalVariant = ModalOpenVariant.ASSET,
  tagIconRef,
  filterButtonRef,
  assetData,
  tagsList,
}: TagsListProps) => {
  const { openPopout, togglePopout, toggleFilterPopout, toggleAlertTagsPopout } = useTagsStore()
  let visibleTags: AssetTag[] = []
  let hiddenCount = 0

  if (tagsList && tagsList.length > 0) {
    visibleTags = tagsList.slice(0, maxTagsRenderCount)
    hiddenCount = tagsList.length - visibleTags.length
  }

  const handleTagClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    switch (modalVariant) {
      case ModalOpenVariant.FILTER: {
        // Anchor to filterButtonRef if provided, otherwise to the clicked element
        const rect = (filterButtonRef?.current || e.currentTarget).getBoundingClientRect()
        toggleFilterPopout({ position: { x: rect.left, y: rect.bottom } })
        break
      }

      case ModalOpenVariant.ALERT: {
        // The alert tag selector is only reachable from the tag icon
        if (!tagIconRef?.current) {
          openModal(modalVariant)
          break
        }

        const rect = tagIconRef.current.getBoundingClientRect()
        toggleAlertTagsPopout({ position: { x: rect.left, y: rect.bottom } })
        break
      }

      case ModalOpenVariant.ASSET: {
        if (!tagIconRef?.current) {
          // No ref means header context: anchor the popout to the click instead
          openPopout({
            position: { x: e.clientX, y: e.clientY },
            activeAssetData: assetData,
          })
          break
        }

        // Table cell context, where the row's tag icon is the anchor
        const rect = tagIconRef.current.getBoundingClientRect()
        togglePopout({
          position: { x: rect.left, y: rect.bottom },
          activeAssetData: assetData,
        })
        break
      }

      default:
        // Any variant without a popout of its own opens the modal
        openModal(modalVariant)
    }
  }

  return (
    <>
      {visibleTags.map(({ id, color, name }) => (
        <Badge
          onClick={(e) => handleTagClick(e)}
          key={`${name}-${id}`}
          minSize={20}
          backgroundColor={color}
          variant={BadgeVariant.TAG}
        >
          <Truncate content={name} limit={15} />
        </Badge>
      ))}
      {hiddenCount > 0 && (
        <span
          className={styles.extraTagsCount}
          onClick={(e) => {
            handleTagClick(e)
          }}
        >
          +{hiddenCount}
        </span>
      )}
    </>
  )
}
